export default __webpack_public_path__ + "static/media/spinner.781cef0f.svg";